export class Comission {
    comissionId: string
    companyId: string
    createdAt: Date
    updatedAt: Date
    userId: string
    type: ComissionTypeEnum
    value: number
    status: number
    description: string
    paidAt: Date
}

export enum ComissionTypeEnum {
    credit = 'credit',
    debit = 'debit',
}
